import { render, staticRenderFns } from "./NewForgottenPasswordComponent.vue?vue&type=template&id=3787cc20&"
import script from "./NewForgottenPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./NewForgottenPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewForgottenPasswordComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports